// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SelectPDFTemplate_wrapper__f9SZM","templates-wrapper":"SelectPDFTemplate_templates-wrapper__eJyU9","selected":"SelectPDFTemplate_selected__H1fVf"};